export enum XboxNetworkFeatures {
  crossOwnership = "crossOwnership",
  crossSave = "crossSave",
  crossProgression = "crossProgression",
  sharedAchievements = "sharedAchievements",
  smartDelivery = "smartDelivery",
}
